<script setup lang="ts">
const props = defineProps<{
    type?: string;
    message?: string;
    selected?: boolean;
}>();
</script>
<template>
    <hr>
    <h5 v-show="!props.selected">
        {{ props.message || `Seleziona ${props.type || 'solo una riga'}, per visualizzare dettagli.` }}
    </h5>
    <div v-show="props.selected">
        <slot />
    </div>
</template>
